import * as Zod from 'zod';

import { IExpiryScale } from 'graphql/types';
import { scoringValidator } from 'common/validators/scoring';

export const certificateValidator = Zod.object({
    __typename: Zod.literal('Certificate'),
    id: Zod.string(),
    name: Zod.string(),
    expiry: Zod.number().nullable().optional(),
    expiryScale: Zod.enum(IExpiryScale).nullable().optional(),
    scoring: Zod.array(scoringValidator),
});
